import React, { Component } from "react"
import { connect } from "react-redux"
import { TableHeaderColumn } from "react-bootstrap-table"
import "react-bootstrap-table/dist/react-bootstrap-table.min.css"
import { DckSelectors, DckActionCreators } from "dck-redux"

import * as ItemTypes from "../../redux/items/types"
import { Link } from "react-router"
import FontAwesome from "react-fontawesome"
import {
  DEFAULT_NAV_PAGE,
  DEFAULT_NAV_SIZE,
  getCustomerFullName,
  getDefaultPagedResult,
  scrollToTop } from "../../lib/utils"
import CustomerTable from "./CustomerTable"
import UIAvatar from "../fragments/UIAvatar"
import {
  buildCustomerQueryString,
  checkAndRoute,
  getCustomerSortKeyFromBootstrapTable,
  handleSortChange
} from "../../lib/queryStringBuilder"
import CustomerSeachPanel from "./CustomerSeachPanel"
import PropTypes from 'prop-types'

class ListCustomers extends Component {

  static contextTypes = {
    router: PropTypes.object
  }

  componentDidMount() {
    this.props.loadBusinesses()
    this.readQueryString()
  }

  componentDidUpdate(prevProps) {
    if (this.props.location.search !== prevProps.location.search) {
      this.readQueryString()
    }
  }

  readQueryString = () => {
    const filteringOptions = buildCustomerQueryString(this.props.location)
    this.props.loadCustomers(filteringOptions)
  }

  onPageChange = currentPage => {
    checkAndRoute('page', currentPage, currentPage !== DEFAULT_NAV_PAGE, false,
      this.context, this.props.location)
    scrollToTop()
  }

  onSizePerPageList = sizePerPage => {
    checkAndRoute('size', sizePerPage, sizePerPage !== DEFAULT_NAV_SIZE, true,
      this.context, this.props.location)
    scrollToTop()
  }

  onFilterChange = (filterName, filterValue) =>{
    checkAndRoute(filterName, filterValue, !!filterValue, true,
      this.context, this.props.location)
    scrollToTop()
  }

  onSortChange = (sortName, sortOrder) => {

    handleSortChange(
      getCustomerSortKeyFromBootstrapTable(sortName),
      sortOrder,
      this.context,
      this.props.location
    )
  }

  doClearFilters = () => {
    this.context.router.push({
      pathname: this.props.location.pathname,
    })
  }

  getLinkToDetails = (id, name) =>
    <Link to={`/customers/${id}/detail`} title='Show details' className='p-5'>
      { name }
    </Link>

  render() {

    const { pagedLoans, businesses, setCustomer, location: { query } } = this.props,

    { content, currentPage, pageSize, totalElements } = pagedLoans

    return (
      <div>

        <CustomerSeachPanel
          businesses={ businesses }
          filterChanged={ this.onFilterChange }
          doClearFilters={ this.doClearFilters }
          query={ query }
        />

        <CustomerTable
          items={ content }
          businesses={ businesses }
          setCustomer={ setCustomer }

          dataTotalSize={ totalElements }
          page={ Number(currentPage) + 1 }
          onPageChange={ this.onPageChange }
          sizePerPage={ Number(pageSize) }
          onSizePerPageList={ this.onSizePerPageList }
          onSortChange={ this.onSortChange }>

          <TableHeaderColumn
            dataField="id"
            isKey
            dataAlign="center"
            dataFormat={(_, row) => <UIAvatar name={ getCustomerFullName(row) } size={ 28 } />}
            csvHeader="Customer ID"
            width='48px'
          />

          <TableHeaderColumn
            dataField="firstName"
            dataSort
            dataFormat={(firstName, row) => this.getLinkToDetails(row.id, firstName)}
            csvHeader="First name"
            columnClassName="min-w-120"
          >
            First name
          </TableHeaderColumn>

          <TableHeaderColumn
            dataField="lastName"
            dataSort
            dataFormat={(lastName, row) => this.getLinkToDetails(row.id, lastName)}
            csvHeader="Last name"
            columnClassName="min-w-120"
          >
            Last name
          </TableHeaderColumn>

          <TableHeaderColumn
            dataField="phoneNumber"
            dataSort
            csvHeader="Phone number"
            columnClassName="min-w-120"
          >
            Phone number
          </TableHeaderColumn>

          <TableHeaderColumn
            dataField="affiliated"
            dataSort
            dataFormat={(_, { business }) => business ?
              <Link to={`/businesses/${business.id}/detail`} title="View">
                { business.name } - { business.businessId }
              </Link> : ''
            }
            csvHeader="Affiliation"
            columnClassName="min-w-120"
          >
            Affiliated
          </TableHeaderColumn>

          <TableHeaderColumn
            dataField="createdOnFormatted"
            dataAlign="center"
            dataSort
            csvHeader="Created On"
            columnClassName="text-xs min-w-120"
          >
            Created On
          </TableHeaderColumn>

          <TableHeaderColumn
            dataAlign="center"
            width="80"
            dataFormat={(_, row) => <span className="flex-detail">
              { this.getLinkToDetails(row.id, <FontAwesome name="eye" title='View' />) }
              </span>
            }
          />
        </CustomerTable>
      </div>
    )
  }
}

const mapStateToProps = state => {

  const originalPagedCustomers = DckSelectors.selectAllItems(state, ItemTypes.Customer),
  businesses = DckSelectors.selectAllItems(state, ItemTypes.Business),

  pagedLoans = originalPagedCustomers instanceof Array 
    ? getDefaultPagedResult()
    : originalPagedCustomers

  businesses.reverse()
  return { pagedLoans, businesses }
},

mapDispatchToProps = dispatch => ({

  loadCustomers: filteringOptions => dispatch(DckActionCreators.itemsLoad(ItemTypes.Customer, filteringOptions)),

  setCustomer: (id, data) => dispatch(DckActionCreators.itemSet(ItemTypes.Customer, id, data)),

  loadBusinesses: () => dispatch(DckActionCreators.itemsLoad(ItemTypes.Business)),
})

export default connect(mapStateToProps, mapDispatchToProps)(ListCustomers)



// WEBPACK FOOTER //
// ./src/components/Customers/List.js